import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { questionGroupList, questionList, questionGroupSave, questionGroupDelete, questionSave, questionDelete, questionUpdate } from "@/api/management/QAHelper";
import quillEditorCom from "@/components/common/quillEditor.vue";
import ImportAndDownloadExcel from "@/components/dialog/common/importAndDownloadExcel";
export default {
  name: "setting",
  data: function data() {
    return {
      navPage: {
        current: 1,
        total: 0,
        size: 20
      },
      navList: [],
      activeNav: {},
      questionPage: {
        current: 1,
        total: 0,
        size: 20
      },
      questionList: [],
      activeQuestion: {},
      navLoading: false,
      questionLoading: false,
      addNavDialog: false,
      addNavLoading: false,
      delNavDialogData: {
        show: false,
        data: {}
      },
      newNav: "",
      addQuestionDialog: false,
      addQuestionLoading: false,
      delQuestionDialogData: {
        show: false,
        data: {}
      },
      newQuestion: "",
      answer: "",
      ruleValidate: {
        title: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }, {
          min: 1,
          max: 20,
          message: "长度在 1 到 20 个字符",
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }]
      },
      updateLoading: false,
      activeTabName: "edit",
      importDialog: false
    };
  },
  components: {
    quillEditorCom: quillEditorCom,
    ImportAndDownloadExcel: ImportAndDownloadExcel
  },
  computed: {},
  watch: {
    activeNav: function activeNav(val) {
      this.initQuestionList();
    },
    "activeQuestion.content": function activeQuestionContent(val) {}
  },
  created: function created() {
    this.initNavList();
  },
  methods: {
    importDialogClose: function importDialogClose() {
      this.$refs.importAndDownloadExcel.reset();
      this.importDialog = false;
    },
    navPageChange: function navPageChange(current) {
      this.navPage.current = current;
      this.getNavList();
    },
    activeNavChange: function activeNavChange(item) {
      this.activeNav = item;
    },
    initNavList: function () {
      var _initNavList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.navPage.current = 1;
                _context.next = 3;
                return this.getNavList();

              case 3:
                this.activeNav = this.navList[0] || {};

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initNavList() {
        return _initNavList.apply(this, arguments);
      }

      return initNavList;
    }(),
    getNavList: function getNavList() {
      var _this = this;

      var params = {
        current: this.navPage.current,
        size: this.navPage.size
      };
      this.navLoading = true;
      return new Promise(function (resolve, reject) {
        questionGroupList(params).then(function (_ref) {
          var data = _ref.data;

          if (data.code == 0) {
            _this.navList = data.data.records || [];
            _this.navPage.total = data.data.total;
            resolve();
          } else {
            _this.$message.error(data.msg);
          }
        }).finally(function () {
          _this.navLoading = false;
        });
      });
    },
    initQuestionList: function initQuestionList() {
      this.questionPage.current = 1;
      this.getQuestionList();
    },
    questionPageChange: function questionPageChange(current) {
      this.questionPage.current = current;
      this.getQuestionList();
    },
    getQuestionList: function getQuestionList() {
      var _this2 = this;

      var params = {
        current: this.questionPage.current,
        size: this.questionPage.size,
        groupId: this.activeNav.id
      };
      this.questionLoading = true;
      questionList(params).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.questionList = data.data.records || [];
          _this2.questionPage.total = data.data.total;
        } else {
          _this2.$message.error(data.msg);
        }
      }).finally(function () {
        _this2.questionLoading = false;
      });
    },
    addNav: function addNav() {
      this.addNavDialog = true;
    },
    navDialogClose: function navDialogClose() {
      this.newNav = "";
      this.addNavDialog = false;
    },
    navSubmit: function navSubmit() {
      var _this3 = this;

      if (!this.newNav) {
        return;
      }

      if (this.newNav.length > 10) {
        this.$message.warning("请输入10字以内的问题导航");
        return;
      }

      this.addNavLoading = true;
      questionGroupSave({
        name: this.newNav
      }).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this3.$message.success("添加成功");

          _this3.initNavList();

          _this3.addNavDialog = false;
        } else {
          _this3.$$message.error(data.msg);
        }
      }).finally(function () {
        _this3.addNavLoading = false;
      });
    },
    deleteNavDialog: function deleteNavDialog(item) {
      if (item.questionCount != 0) {
        this.$message.warning("该导航下内容不为空不允许删除");
        return;
      }

      this.delNavDialogData.show = true;
      this.delNavDialogData.data = item;
    },
    delNav: function delNav() {
      var _this4 = this;

      questionGroupDelete({
        ids: this.delNavDialogData.data.id
      }).then(function (_ref4) {
        var data = _ref4.data;

        if (data.code == 0) {
          _this4.$message.success("删除成功");

          _this4.delNavDialogData.show = false;

          _this4.initNavList();
        } else {
          _this4.$message.error(data.msg);
        }
      });
    },
    addQuestion: function addQuestion() {
      this.addQuestionDialog = true;
    },
    questionDialogClose: function questionDialogClose() {
      this.newQuestion = "";
      this.addQuestionDialog = false;
    },
    questionSubmit: function questionSubmit() {
      var _this5 = this;

      if (!this.newQuestion) {
        return;
      }

      if (this.newQuestion.length > 20) {
        this.$message.warning("请输入20字以内的问题");
        return;
      }

      this.addQuestionLoading = true;
      questionSave({
        title: this.newQuestion,
        groupId: this.activeNav.id
      }).then(function (_ref5) {
        var data = _ref5.data;

        if (data.code == 0) {
          _this5.$message.success("添加成功");

          _this5.initQuestionList();

          _this5.addQuestionDialog = false;
        } else {
          _this5.$message.error(data.msg);
        }
      }).finally(function () {
        _this5.addQuestionLoading = false;
      });
    },
    activeQuestionChange: function activeQuestionChange(item) {
      this.activeQuestion = JSON.parse(JSON.stringify(item));
    },
    answerSubmit: function answerSubmit() {
      var _this6 = this;

      this.$refs.answerForm.validate(function (valid) {
        if (valid) {
          _this6.updateLoading = true;
          var obj = {
            content: _this6.activeQuestion.content,
            id: _this6.activeQuestion.id,
            title: _this6.activeQuestion.title,
            groupId: _this6.activeQuestion.groupId
          };
          questionUpdate(obj).then(function (_ref6) {
            var data = _ref6.data;

            if (data.code == 0) {
              _this6.$message.success("保存成功");

              _this6.initQuestionList();
            } else {
              _this6.$message.error(data.msg);
            }
          }).finally(function () {
            _this6.updateLoading = false;
          });
        }
      });
    },
    deleteQuestionDialog: function deleteQuestionDialog(item) {
      this.delQuestionDialogData.show = true;
      this.delQuestionDialogData.data = item;
    },
    delQuestion: function delQuestion() {
      var _this7 = this;

      questionDelete({
        ids: this.delQuestionDialogData.data.id
      }).then(function (_ref7) {
        var data = _ref7.data;

        if (data.code == 0) {
          _this7.$message.success("删除成功");

          _this7.delQuestionDialogData.show = false;

          _this7.initQuestionList();
        } else {
          _this7.$message.error(data.msg);
        }
      });
    }
  }
};